module.exports = __webpack_public_path__ + "img/other.0c6eb028.svg";